import { useCallback, useEffect, useRef } from 'react';
import type { ILeaderBoardResponse } from '@/entities/Leaderboard/types/ILeaderBoardResponse';
import { getLeaderboardSocket } from '@/libs/leaderboardSocket.client';
interface UseCompetitionFinishedOptions {
  onCompetitionFinished?: () => void;
  onCompetitionStarted?: () => void;
}
export const useCompetitionFinished = (onCompetitionFinishedOrOptions: (() => void) | UseCompetitionFinishedOptions = {}) => {
  const isFunction = typeof onCompetitionFinishedOrOptions === 'function';
  const options: UseCompetitionFinishedOptions = isFunction ? {
    onCompetitionFinished: onCompetitionFinishedOrOptions
  } : onCompetitionFinishedOrOptions;
  const onCompetitionFinishedRef = useRef(options.onCompetitionFinished);
  const onCompetitionStartedRef = useRef(options.onCompetitionStarted);
  const lastIsActiveRef = useRef<boolean | null>(null);
  onCompetitionFinishedRef.current = options.onCompetitionFinished;
  onCompetitionStartedRef.current = options.onCompetitionStarted;
  const handleSnapshot = useCallback((data: ILeaderBoardResponse) => {
    const {
      isActive
    } = data;

    // Detect when competition finishes
    if (lastIsActiveRef.current === true && isActive === false) {
      onCompetitionFinishedRef.current?.();
    }

    // Detect when competition starts (reset state)
    if (lastIsActiveRef.current === false && isActive === true) {
      onCompetitionStartedRef.current?.();
    }
    lastIsActiveRef.current = isActive;
  }, []);
  useEffect(() => {
    const socket = getLeaderboardSocket();
    if (!socket) return;
    socket.on('leaderboard_snapshot', handleSnapshot);
    return () => {
      socket.off('leaderboard_snapshot', handleSnapshot);
    };
  }, [handleSnapshot]);
};